import { createSlice } from '@reduxjs/toolkit';
import { fetchFolders } from '../thunks/folders';
import {
  createFolder,
  fetchFolder,
  updateFolder,
  deleteFolder,
  downloadSelectedPhotos,
  fetchDownloadStatus,
} from '../thunks/folder';
import findIndex from 'lodash/findIndex';

const initialState = {
  folders: [],
  folder: {},
  s3DownloadList: [],
  folderNameBeforeUpdate: '',
  isFolderNameEditing: false,
  isFolderVideoLinkEditing: false,
  downloadingFolders: [],
  openCollapsablesection: false,
  downloadStarted: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  deleting: false,
  deleteError: '',
};

export const foldersSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {
    updateFolderName: (state, action) => {
      const { id, name } = action.payload;
      state.folders[
        findIndex(state.folders, (folder) => folder.id === id)
      ].name = name;
      state.folder.name = name;
    },
    setFolderNameEditing: (state, action) => {
      state.isFolderNameEditing = action.payload;
    },
    resetFolderNameEditing: (state, action) => {
      const { id } = action.payload;
      state.isFolderNameEditing = false;
      state.folder.name = state.folderNameBeforeUpdate;
      state.folders[
        findIndex(state.folders, (folder) => folder.id === id)
      ].name = state.folderNameBeforeUpdate;
    },
    setCurrentFolder: (state, action) => {
      state.folder = { ...state.folder, ...action.payload };
    },
    setFolderVideoLinkEdit: (state, action) => {
      state.isFolderVideoLinkEditing = action.payload;
    },
    setFolderNameBeforeUpdate: (state, action) => {
      state.folderNameBeforeUpdate = action.payload;
    },
    setDownloadingFolders: (state, action) => {
      const existingFolderIndex = state.downloadingFolders.findIndex(
        (folder) => folder.id === action.payload.id
      );
      if (existingFolderIndex >= 0) {
        // If the folder exists, update it
        state.downloadingFolders[existingFolderIndex] = {
          ...state.downloadingFolders[existingFolderIndex],
          ...action.payload,
        };
      } else {
        // If the folder does not exist, add it to the array
        state.downloadingFolders.push(action.payload);
      }
    },
    setCollapsablesection: (state, action) => {
      state.openCollapsablesection = action.payload;
      state.downloadStarted = true;
    },
  },
  extraReducers: {
    [fetchFolders.pending]: (state) => {
      state.fetching = true;
    },
    [fetchFolders.fulfilled]: (state, action) => {
      state.fetching = false;
      state.folders = action.payload;
    },
    [fetchFolders.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload;
    },
    [createFolder.pending]: (state) => {
      state.saving = true;
    },
    [createFolder.fulfilled]: (state, action) => {
      state.saving = false;
      state.folders = [...state.folders, action.payload];
    },
    [createFolder.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload;
    },
    [fetchFolder.pending]: (state) => {
      state.saving = true;
    },
    [fetchFolder.fulfilled]: (state, action) => {
      state.saving = false;
      state.folder = action.payload;
    },
    [fetchFolder.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload;
    },
    [updateFolder.pending]: (state) => {
      state.saving = true;
    },
    [updateFolder.fulfilled]: (state) => {
      state.saving = false;
      state.isFolderNameEditing = false;
    },
    [updateFolder.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload;
    },
    [deleteFolder.pending]: (state) => {
      state.deleting = true;
    },
    [deleteFolder.fulfilled]: (state, action) => {
      const folderIndex = findIndex(
        state.folders,
        (folder) => folder.id === action.payload
      );
      state.deleting = false;
      state.folders.splice(folderIndex, 1);
    },
    [deleteFolder.rejected]: (state, action) => {
      state.deleting = false;
      state.saveError = action.payload;
    },
    [downloadSelectedPhotos.pending]: (state) => {
      state.saving = true;
    },
    [downloadSelectedPhotos.fulfilled]: (state, action) => {
      state.saving = false;
    },
    [downloadSelectedPhotos.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload;
    },
    [fetchDownloadStatus.pending]: (state) => {
      state.fetching = true;
    },
    [fetchDownloadStatus.fulfilled]: (state, action) => {
      state.fetching = false;
      state.s3DownloadList = action.payload;
    },
    [fetchDownloadStatus.rejected]: (state, action) => {
      state.fetching = false;
      state.saveError = action.payload;
    },
  },
});

export const {
  setCurrentFolder,
  updateFolderName,
  setFolderNameEditing,
  resetFolderNameEditing,
  setFolderVideoLinkEdit,
  setFolderNameBeforeUpdate,
  setDownloadingFolders,
  setCollapsablesection,
} = foldersSlice.actions;
